import { Skeleton } from "antd";

export const CartDrawerSkeleton = () => (
  <div className="cart-drawer-skeleton">
    <div className="cart-drawer-skeleton__summary">
      <div className="cart-drawer-skeleton__pills">
        <Skeleton.Button active size="small" />
        <Skeleton.Button active size="small" />
      </div>
      <Skeleton
        active
        paragraph={{ rows: 2, width: ["45%", "80%"] }}
        title={false}
      />
      <Skeleton.Button active block size="large" />
    </div>
    <div className="cart-drawer-skeleton__items">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          className="cart-drawer-skeleton__item"
          key={`cart-skeleton-${index.toString()}`}
        >
          <Skeleton.Avatar active shape="square" size={84} />
          <div className="cart-drawer-skeleton__copy">
            <Skeleton
              active
              paragraph={{ rows: 2, width: ["100%", "58%"] }}
              title={false}
            />
            <div className="cart-drawer-skeleton__row">
              <Skeleton.Button active size="small" />
              <Skeleton.Button active size="small" />
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);
